export default "__VITE_ASSET__DF_AaEoa__"